import "./frontend.scss"
import React, { useState, useEffect, useMemo } from "react"
import ReactDOM from "react-dom"
import OurComponent from './component/search_filter/frontend_filter_page';

import Rem_filter_page from './component/filter_page/filter_page';
import MembershipBarSection from "./component/professionals_single_page/section/membershipBarSection";
import Rem_service_single_page from './component/professionals_single_page/professionals_single_page';
import ReviewSection from "./component/reviewSection/reviewSection";
import ReviewFirstsection from "./component/reviewSection/reviewFirstsection";
import ReviewSecondSection from "./component/reviewSection/reviewSecondSection";
import ReviewSuccess from "./component/reviewSection/ReviewSuccess";
import Bussiness_cardsection from "./component/bussiness_card/bussiness_card_section";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import common_en from "./translations/en/common.json";
import common_el from "./translations/el/common.json";

i18next.init({
    interpolation: { escapeValue: false },  // React already does escaping
    lng: 'el',                              // language to use
    resources: {
        en: {
            common: common_en               // 'common' is our custom namespace
        },
        el: {
            common: common_el               // 'common' is our custom namespace
        }
    },
});

i18next.init({
    interpolation: { escapeValue: false },  // React already does escaping
});

const divsToUpdate = document.querySelectorAll(".boilerplate-update-me")
divsToUpdate.forEach(div => {
    const data = JSON.parse(div.querySelector("pre").innerText)
    ReactDOM.render(
        <I18nextProvider i18n={i18next}>
            <React.Suspense fallback={<>...</>}>
                <OurComponent {...data} />
            </React.Suspense>
        </I18nextProvider>
        , div)
    div.classList.remove("boilerplate-update-me")
});

const divsToUpdateFilterPage = document.querySelectorAll(".rem-filter-page")
divsToUpdateFilterPage.forEach(div => {
    const data = JSON.parse(div.querySelector("pre").innerText)
    ReactDOM.render(
        <I18nextProvider i18n={i18next}>
            <React.Suspense fallback={<>...</>}>
                <Rem_filter_page {...data} />
            </React.Suspense>
        </I18nextProvider>
        , div)
    div.classList.remove("rem-filter-page")
    div.parentNode.classList.remove("rem-filter-page1")
});



const divsToUpdateFilterSinglePage = document.querySelectorAll(".rem-filter-single-page")
divsToUpdateFilterSinglePage.forEach(div => {
    const data = JSON.parse(div.querySelector("pre").innerText)
    ReactDOM.render(
        <I18nextProvider i18n={i18next}>
            <React.Suspense fallback={<>...</>}>
                <Rem_service_single_page {...data} />
            </React.Suspense>
        </I18nextProvider>
        , div)
    div.classList.remove("rem-filter-single-page")
});



const divsToSendReview = document.querySelectorAll(".rem-send-review")
divsToSendReview.forEach(div => {
    const data = JSON.parse(div.querySelector("pre").innerText)
    ReactDOM.render(
        <I18nextProvider i18n={i18next}>
            <React.Suspense fallback={<>...</>}>
                <ReviewSection {...data} />
            </React.Suspense>
        </I18nextProvider>
        , div)
    div.classList.remove("rem-send-review")
});

const divsToUpdate1 = document.querySelectorAll(".rem_first_review_section")
divsToUpdate1.forEach(div => {
    const data = JSON.parse(div.querySelector("pre").innerText)
    ReactDOM.render(
        <I18nextProvider i18n={i18next}>
        <React.Suspense fallback={<>...</>}>
            <ReviewFirstsection {...data} />
        </React.Suspense>
        </I18nextProvider>
 , div)
    div.classList.remove("rem_first_review_section")
});

const divsToUpdate2 = document.querySelectorAll(".rem_second_review_section")
divsToUpdate2.forEach(div => {
    const data = JSON.parse(div.querySelector("pre").innerText)
    ReactDOM.render(
        <React.Suspense fallback={<>...</>}>
            <ReviewSecondSection {...data} />
        </React.Suspense>
 , div)
    div.classList.remove("rem_second_review_section")
});

const divsToUpdate3 = document.querySelectorAll(".rem_thired_review_callback")
divsToUpdate3.forEach(div => {
    const data = JSON.parse(div.querySelector("pre").innerText)
    ReactDOM.render(
        <I18nextProvider i18n={i18next}>
        <React.Suspense fallback={<>...</>}>
            <ReviewSuccess {...data} />
        </React.Suspense>
        </I18nextProvider>
 , div)
    div.classList.remove("rem_thired_review_callback")
});

const divsToUpdate4 = document.querySelectorAll(".rem_bussiness_card_callback")
divsToUpdate4.forEach(div => {
    const data = JSON.parse(div.querySelector("pre").innerText)
    ReactDOM.render(
        <I18nextProvider i18n={i18next}>
        <React.Suspense fallback={<>...</>}>
            <Bussiness_cardsection {...data} />
        </React.Suspense>
        </I18nextProvider>
 , div)
    div.classList.remove("rem_bussiness_card_callback")
});